import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'src/components/tooltip';

const propTypes = {
  achievementItem: PropTypes.shape({
    name: PropTypes.string.isRequired,
    emoji: PropTypes.string.isRequired,
  }).isRequired,
};

const AwardsList = ({achievementItem}) => {
  if (!achievementItem) {
    return null;
  }

  return (
    <Tooltip title={achievementItem.name} placement="top">
      <span
        alt={achievementItem.name}
        className="college-discovery-step-college-card-awards-list-item"
      >
        {achievementItem.emoji}
      </span>
    </Tooltip>
  );
};

AwardsList.propTypes = propTypes;

export default AwardsList;
